import type { MenuEntryCategory, MenuEntryLink } from '@gql-generated/graphql'

type MaybeMenuEntry =
  | StrictPick<MenuEntryLink, '__typename' | 'openInNewTab'>
  | StrictPick<MenuEntryCategory, '__typename'>

/**
 * Returns whether a menu entry should open in a new tab.
 * Only `MenuEntryLink` entries can have `openInNewTab: true`.
 */
export function getEntryOpensInNewTab(entry: MaybeMenuEntry): boolean {
  return entry.__typename === 'MenuEntryLink' ? (entry.openInNewTab ?? false) : false
}
